import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

// Import Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import CustomCursor from './components/CustomCursor';
import PageLoader from './components/PageLoader';
import RouteChangeHandler from './components/RouteChangeHandler';
import FloatingKeywords from './components/FloatingKeywords';
import SmoothScroll from './components/SmoothScroll'; // <-- NEW
import AnimatedRoutes from './components/AnimatedRoutes'; // <-- NEW

// Import the Provider
import { LoadingProvider } from './context/LoadingContext';

function App() {

  // This logic for the *initial* preloader is still needed
  useEffect(() => {
    const preloader = document.getElementById('preloader');
    if (preloader) {
      preloader.classList.add('loaded');
    }
  }, []);

  return (
    // Wrap the *entire* app in the LoadingProvider
    <LoadingProvider>
      <Router>
        <SmoothScroll /> {/* Add Smooth Scroll logic */}
        <CustomCursor />
        <FloatingKeywords /> {/* Floating coding keywords background */}
        <PageLoader /> {/* Add the new page loader */}
        <RouteChangeHandler /> {/* Add the route change handler */}

        <Navbar />
        <main>
          <AnimatedRoutes /> {/* Use the new AnimatedRoutes component */}
        </main>
        <Footer />
      </Router>
    </LoadingProvider>
  );
}

export default App;